import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function FlightPurchaseAddOnsTable(props: {
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const name = `approvalable.flightPurchases.${props.parentIndex}.flightPurchaseAddOns`;
  const values = HOCWatchValue({ keys: [name] });
  const data = values[name];

  const columns = [
    {
      header: t('common:name'),
      accessorKey: 'guestName',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:route'),
      accessorKey: 'route',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];

  if (!data.length) {
    return null;
  }

  return (
    <>
      <Separator gap={24} />

      <div style={{ width: '100%' }}>
        <TableEditableComponent
          columns={columns}
          dispatch={() => {}}
          disabled
          data={data}
          name={name}
        />
      </div>
    </>
  );
}
